module.exports = __webpack_public_path__ + "img/car-border.9c1887a1.png";